import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { Settings as LuxonSettings } from "luxon";

import plCommon from "./locales/pl/common.json";
import plNavigation from "./locales/pl/navigation.json";
import plDashboard from "./locales/pl/dashboard.json";
import plLeads from "./locales/pl/leads.json";
import plJobs from "./locales/pl/jobs.json";
import plStock from "./locales/pl/stock.json";
import plProduction from "./locales/pl/production.json";
import plVehicles from "./locales/pl/vehicles.json";
import plProfile from "./locales/pl/profile.json";
import plTill from "./locales/pl/till.json";
import plAccounts from "./locales/pl/accounts.json";
import plWorkOrders from "./locales/pl/workOrders.json";
import plReports from "./locales/pl/reports.json";
import plChat from "./locales/pl/chat.json";
import plTickets from "./locales/pl/tickets.json";
import plMessages from "./locales/pl/messages.json";

export const supportedLanguages = [
  { code: "en", label: "English", short: "EN" },
  { code: "pl", label: "Polski", short: "PL" },
];

// Keys are the English source text, so no `en` resources are needed —
// any key missing from the Polish files simply renders in English.
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      pl: {
        common: plCommon,
        navigation: plNavigation,
        dashboard: plDashboard,
        leads: plLeads,
        jobs: plJobs,
        stock: plStock,
        production: plProduction,
        vehicles: plVehicles,
        profile: plProfile,
        till: plTill,
        accounts: plAccounts,
        workOrders: plWorkOrders,
        reports: plReports,
        chat: plChat,
        tickets: plTickets,
        messages: plMessages,
      },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "pl"],
    defaultNS: "common",
    // English sentences are used as keys, so dots/colons must not be treated
    // as nesting or namespace separators.
    keySeparator: false,
    nsSeparator: false,
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ["localStorage"],
      caches: ["localStorage"],
      lookupLocalStorage: "language",
    },
    returnNull: false,
  });

// Luxon drives the planner day headers (toFormat("ccc d LLL") etc.), so its default locale follows the
// UI language. English keeps the browser locale so en-GB date ordering is untouched.
const systemLuxonLocale = LuxonSettings.defaultLocale;
const applyLanguage = (lng: string) => {
  document.documentElement.lang = lng;
  LuxonSettings.defaultLocale = lng === "pl" ? "pl" : systemLuxonLocale;
};

i18n.on("languageChanged", applyLanguage);
applyLanguage(i18n.language);

export default i18n;
